import { IState, getStore } from './store';

export { getStore, IState, IPagesState, getPagesState } from './store';

export function getState(): IState {
    return getStore().getState();
}
